import { css } from '@emotion/react'
import { Colours, Fonts } from '../../../../style_helpers'

const styles = (colour = Colours('grey', '500')) => css`
  margin: 0;
  font-family: ${Fonts('gibsonSemiBold')};
  line-height: 1.25em;
  color: ${colour};
`

export default styles
